// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "svg[data-v-2892ca94]{margin-bottom:52px;margin-top:52px}.error-code[data-v-2892ca94]{font-weight:400}.link[data-v-2892ca94]{color:#007aff!important;font-size:26px;-webkit-text-decoration-line:underline!important;text-decoration-line:underline!important}.message[data-v-2892ca94]{color:var(--text-contast);font-size:34px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
